import React from 'react';
import { createIcon } from './create-icon';
import './icon-upload-assets.scss';

export const IconUploadAssets = createIcon(<div className="icon-upload-assets" />);
export const IconUploadAssetsDisabled = createIcon(
  <div className="icon-upload-assets filter-disabled" />,
);
